(function () {
  function tt() {
    return typeof window.ttq !== "undefined" ? window.ttq : null;
  }

  function track(event, data) {
    var t = tt();
    if (!t || typeof t.track !== "function") return;
    try {
      t.track(event, data);
    } catch (e) {}
  }

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function whenTtqReady(fn) {
    var t = tt();
    if (t && typeof t.ready === "function") {
      t.ready(fn);
    } else {
      fn();
    }
  }

  ready(function () {
    whenTtqReady(function () {
      var vc = readJson("tiktok-view-content-data");
      if (vc && vc.content_id) {
        track("ViewContent", {
          contents: [
            {
              content_id: String(vc.content_id),
              content_type: vc.content_type || "product",
              content_name: vc.content_name || ""
            }
          ],
          value: Number(vc.value) || 0,
          currency: vc.currency || "USD"
        });
      }

      var col = readJson("tiktok-collection-view-data");
      if (col && col.content_id) {
        track("ViewContent", {
          contents: [
            {
              content_id: String(col.content_id),
              content_type: "product_group",
              content_name: col.content_name || ""
            }
          ],
          value: Number(col.value) || 0,
          currency: col.currency || "USD"
        });
      }

      var sr = readJson("tiktok-search-data");
      if (sr && sr.query) {
        track("Search", {
          query: sr.query,
          value: Number(sr.value) || 0,
          currency: sr.currency || "USD"
        });
      }
    });
  });

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || !form.action) return;
      var action = String(form.action || "");
      if (action.indexOf("/cart/add") === -1) return;

      var sub = e.submitter;
      if (sub && sub.name && sub.name !== "add") return;

      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      var vid = String(idInput.value);
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty < 1) qty = 1;

      var meta = readJson("tiktok-pdp-meta");
      if (!meta) return;
      var centsMap = readJson("tiktok-variant-cents") || {};
      var cents = centsMap[vid] != null ? centsMap[vid] : centsMap[Number(vid)];
      if (cents == null) cents = 0;
      var unit = Number(cents) / 100;
      var currency = (meta && meta.currency) || "USD";
      var title = (meta && meta.title) || "";

      whenTtqReady(function () {
        track("AddToCart", {
          contents: [
            {
              content_id: vid,
              content_type: "product",
              content_name: title,
              quantity: qty
            }
          ],
          value: unit * qty,
          currency: currency
        });
      });
    },
    true
  );

  ready(function () {
    var cartForm = document.getElementById("cart");
    if (!cartForm) return;
    cartForm.addEventListener("submit", function (e) {
      var sub = e.submitter;
      if (!sub || sub.name !== "checkout") return;
      var d = readJson("tiktok-initiate-checkout-data");
      if (!d) return;
      whenTtqReady(function () {
        track("InitiateCheckout", {
          contents: d.contents || [],
          value: Number(d.value) || 0,
          currency: d.currency || "USD"
        });
      });
    });
  });
})();
